import { css } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

export default () => {
  return {
    review: css`
      margin-top: ${cssTheme.gu1};
      ${cssTheme.breakpoints.sm} {
        margin-top: ${cssTheme.gu2};
      }
    `,
  };
};
